// DS: DS6.1 - Checkbox Semantics
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import Checkbox from '../../../../Checkbox';
import { setRefs } from '../../../../../utils/refHelpers';
import { useListItem } from '../../common';
import ListItemContent from '../../legos/ListItemContent';
import commonStyles from '../../common.scss';
import s from './ListItemCheckbox.scss';
const ListItemCheckbox = (unfilteredProps)=>{
    const _useListItem = useListItem(unfilteredProps), { rootProps: { className, inputClassName, innerRef, checked, name, value, controlAlignment = 'top' }, contentProps, ref } = _useListItem, rest = _object_without_properties(_useListItem.rootProps, [
        "className",
        "inputClassName",
        "innerRef",
        "checked",
        "name",
        "value",
        "controlAlignment"
    ]);
    return(// TODO: Still not a11y, can't activate the checkbox with keyboard. Need to refactor base checkbox component
    /*#__PURE__*/ React.createElement(Checkbox, _object_spread({
        // TODO: Add role="checkbox"? Use da-a11y checkbox?
        "aria-checked": checked,
        className: c(s['checkbox'], controlAlignment === 'center' && s['align-items-center'], className),
        inputClassName: c(commonStyles['input'], inputClassName),
        // TODO: Refactor away the need to unset the default checkbox font?
        labelClassName: s['label'],
        isChecked: checked,
        id: name,
        innerRef: (node)=>setRefs([
                ref,
                innerRef
            ], node)
    }, rest), /*#__PURE__*/ React.createElement(ListItemContent, contentProps)));
};
ListItemCheckbox.displayName = 'ListItemCheckbox';
export default ListItemCheckbox;
